var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2933 8.207L7.00034 2.914L1.70733 8.207L0.293335 6.793L5.58634 1.5C5.96139 1.12506 6.47001 0.914429 7.00034 0.914429C7.53066 0.914429 8.03928 1.12506 8.41434 1.5L13.7073 6.793L12.2933 8.207Z",
    fill: "#293041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandOpen);
export default __webpack_public_path__ + "static/media/expand_open.6bb9e6e00bfdb733137f186a83c23266.svg";
export { ForwardRef as ReactComponent };